import React from "react";
import { observer } from "mobx-react";
import { InventoryCalculationCutbackEditTemplate } from "themes/application/facility-order/pages";
import { InventoryCalculationCutbackEditViewStore } from "application/facility-order/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new InventoryCalculationCutbackEditViewStore(rootStore), "inventoryCalculationCutbackEditViewStore")
@observer
class InventoryCalculationCutbackEdit extends React.Component {
	render() {
		return <InventoryCalculationCutbackEditTemplate {...this.props} />;
	}
}

export default InventoryCalculationCutbackEdit;